// Colours for Watchlist category pills.
//
// Each category keeps one palette slot (categoryColorIndex), so "AI" has the
// same colour in every row, column and session. Light and dark fills are
// opaque, so the text contrast does not depend on striping, hover or the
// editable-cell tint underneath. High-contrast themes draw an outline in the
// text colour on a transparent background instead of a fill.
import { categoryColorIndex } from './categoryTools';

function tone(background, color, borderColor) {
    return Object.freeze({ background, color, borderColor });
}

function hue(name, light, dark) {
    return Object.freeze({ name, light, dark });
}

// Ten hues spread around the colour wheel. Light: soft tint, dark text.
// Dark: deep fill, light text. Every pair keeps at least 4.5:1 contrast
// (WCAG AA for small text), and the light text colours also keep at least
// 7:1 on white for the light high-contrast theme.
export const CATEGORY_PALETTE = Object.freeze([
    hue('red', tone('#ffe1df', '#9c241b', '#fbc6c1'), tone('#4a1c1a', '#ffc9c3', '#6f2c27')),
    hue('orange', tone('#ffe9d6', '#8a3a0b', '#fbcfa9'), tone('#47260f', '#ffcfa6', '#6b3c19')),
    hue('yellow', tone('#fcf1c2', '#6a5100', '#f0d97c'), tone('#3b3109', '#f3dd8a', '#5a4a12')),
    hue('lime', tone('#e7f5c8', '#405b10', '#c8e59a'), tone('#2b3912', '#d2eb9f', '#43571e')),
    hue('green', tone('#d6f5e4', '#175f3c', '#a9e4c4'), tone('#13392a', '#a7eac6', '#1f5840')),
    hue('teal', tone('#d3f0f6', '#125a69', '#a6dbe7'), tone('#103743', '#a8e2ee', '#1b5565')),
    hue('blue', tone('#dde8ff', '#1f4cab', '#bcd0fb'), tone('#1a2f57', '#bcd3ff', '#2a4881')),
    hue('purple', tone('#ebe5ff', '#563ba8', '#d3c7fb'), tone('#2f2559', '#d6cbff', '#473a84')),
    hue('magenta', tone('#fbe1f1', '#8c2c69', '#f2bedf'), tone('#45193b', '#f5c2e3', '#672858')),
    hue('gray', tone('#e8ebf0', '#434d5a', '#cdd3dc'), tone('#2d333c', '#d6dbe3', '#47505d')),
]);

/**
 * The palette entry of a category ({ name, light, dark }, each tone
 * { background, color, borderColor }), or null for a blank value (blank
 * cells show a dash, not a pill). High-contrast themes keep the tone's text
 * colour and draw it as an outline on a transparent background (see
 * CategoryPill).
 */
export function getCategoryPillHue(value) {
    const index = categoryColorIndex(value, CATEGORY_PALETTE.length);
    return index < 0 ? null : CATEGORY_PALETTE[index];
}
